import { render, staticRenderFns } from "./Uscita_materiale.vue?vue&type=template&id=ffaf9576&"
import script from "./Uscita_materiale.vue?vue&type=script&lang=js&"
export * from "./Uscita_materiale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports